module.exports = __webpack_public_path__ + "img/icon_monitor.c36d85cf.svg";